import { useRef, useState } from "react";
import { Modal, Button } from "@etframework/ui.components";
import { useDeleteBoard } from "../../data/mutations/boardMutations";
import { useTranslation } from "react-i18next";
import useModalEvent from "../../hooks/useModalEvent";
import ReactDOM from "react-dom";
import { toast } from "react-toastify";
import { useParams, useNavigate } from "react-router-dom";

export const DeleteBoardConfirmationModal = () => {
  const navigate = useNavigate();
  const { boardId } = useParams();
  const { mutate: deleteBoard, isPending } = useDeleteBoard();
  const { t } = useTranslation(["Boards"], {
    useSuspense: false,
  });

  const onDeleteBoard = () => {
    deleteBoard(
      { id: boardId },
      {
        onSuccess: () => {
          onModalClose();
          toast.success(t("DeleteBoardModal.DeleteSuccess"), {
            position: "bottom-left",
          });
          navigate(`/duedates/settings/boards`);
        },
        onError: () => {
          toast.error(t("DeleteBoardModal.ErrorMsg"), {
            position: "bottom-left",
          });
          onModalClose();
        },
      }
    );
  };

  //Modal
  const modalRef = useRef();
  const { ModalEvents, useRegisterEvent } = useModalEvent();
  const [showModal, setShowModal] = useState(false);

  const onModelBeforeClose = () => {};

  const onModalClose = () => {
    setShowModal(false);
  };

  const closeModal = () => {
    setShowModal(false);
    modalRef?.current?.close();
  };

  const openModal = () => {
    setShowModal(true);
    modalRef?.current?.open();
  };

  const toggleModal = () => {
    if (showModal) {
      closeModal();
      return;
    } else {
      openModal();
    }
  };

  const ModalContent = () => {
    return (
      <div className="et-board-modal">
        <span className="board-header d-block">
          {t("DeleteBoardModal.DeleteBoardHeader")}
        </span>

        <div className="mb-3">{t("DeleteBoardModal.DeleteBoardMessage1")}</div>

        <div className="d-flex justify-content-end board-modal-btns mx-auto gap-3">
          <Button
            text={t("DeleteBoardModal.Cancel")}
            className="btn-tertiary"
            onClick={toggleModal}
          />
          <Button
            id={ModalEvents.DeleteBoardConfirmationModal.Id + "_delete-button"}
            text={t("DeleteBoardModal.DeleteBoard")}
            className="btn btn-danger"
            onClick={onDeleteBoard}
            loading={isPending}
          />
        </div>
      </div>
    );
  };

  useRegisterEvent(ModalEvents.DeleteBoardConfirmationModal, toggleModal);

  return ReactDOM.createPortal(
    <>
      <Modal
        id={ModalEvents.DeleteBoardConfirmationModal.Id}
        ref={modalRef}
        isModal
        showCloseIcon={true}
        visible={showModal}
        content={<ModalContent />}
        close={onModalClose}
        beforeClose={onModelBeforeClose}
        minHeight="20vh"
        width="487px"
      ></Modal>
    </>,
    document.body
  );
};
